export default __webpack_public_path__ + "static/media/packages-logo.1b8c69d9.png";